import gql from 'graphql-tag';

export default gql`
  query brokerPhoneRateLimitQuery($layerID: String) {
    brokerPhoneRateLimit(layerID: $layerID)
  }
`;
